var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 4C2.75 3.0335 3.5335 2.25 4.5 2.25H9.5C10.4665 2.25 11.25 3.0335 11.25 4V7C11.25 7.9665 10.4665 8.75 9.5 8.75H4.5C3.5335 8.75 2.75 7.9665 2.75 7V4ZM4.5 3.75C4.36193 3.75 4.25 3.86193 4.25 4V7C4.25 7.13807 4.36193 7.25 4.5 7.25H9.5C9.63807 7.25 9.75 7.13807 9.75 7V4C9.75 3.86193 9.63807 3.75 9.5 3.75H4.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 4C12.75 3.0335 13.5335 2.25 14.5 2.25H19.5C20.4665 2.25 21.25 3.0335 21.25 4V12C21.25 12.9665 20.4665 13.75 19.5 13.75H14.5C13.5335 13.75 12.75 12.9665 12.75 12V4ZM14.5 3.75C14.3619 3.75 14.25 3.86193 14.25 4V12C14.25 12.1381 14.3619 12.25 14.5 12.25H19.5C19.6381 12.25 19.75 12.1381 19.75 12V4C19.75 3.86193 19.6381 3.75 19.5 3.75H14.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 12C2.75 11.0335 3.5335 10.25 4.5 10.25H9.5C10.4665 10.25 11.25 11.0335 11.25 12V20C11.25 20.9665 10.4665 21.75 9.5 21.75H4.5C3.5335 21.75 2.75 20.9665 2.75 20V12ZM4.5 11.75C4.36193 11.75 4.25 11.8619 4.25 12V20C4.25 20.1381 4.36193 20.25 4.5 20.25H9.5C9.63807 20.25 9.75 20.1381 9.75 20V12C9.75 11.8619 9.63807 11.75 9.5 11.75H4.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 17C12.75 16.0335 13.5335 15.25 14.5 15.25H19.5C20.4665 15.25 21.25 16.0335 21.25 17V20C21.25 20.9665 20.4665 21.75 19.5 21.75H14.5C13.5335 21.75 12.75 20.9665 12.75 20V17ZM14.5 16.75C14.3619 16.75 14.25 16.8619 14.25 17V20C14.25 20.1381 14.3619 20.25 14.5 20.25H19.5C19.6381 20.25 19.75 20.1381 19.75 20V17C19.75 16.8619 19.6381 16.75 19.5 16.75H14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.91842bde24d865752088f0753a594560.svg";
export { ForwardRef as ReactComponent };